import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    spinnerLabel: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Accessible label for the spinner shown while loading the next page of results */
            spinnerLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "LoadingMoreIndicator.spinnerLabel?c=1aadd5rwp0agd", defaultMessage: "Next page loading" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
